export const amenityViewPath = (id: string): string => `/amenities/${id}/view`;

const INTERACTIVE_SELECTOR =
  'a, button, input, select, textarea, label, [role="switch"], [role="button"], [role="checkbox"], [role="menuitem"]';

type ClosestTarget = { closest?: (selector: string) => unknown } | null;

/**
 * Клик или Enter на строке ведёт на просмотр, только если событие пришло не из
 * вложенного интерактивного элемента (Edit, Delete, Switch).
 */
export const isRowActivation = (target: ClosestTarget): boolean => {
  if (!target || typeof target.closest !== "function") return true;
  return !target.closest(INTERACTIVE_SELECTOR);
};

/** Форма в режиме просмотра не показывает кнопку сохранения. */
export const showAmenityFormSubmit = (readOnly: boolean): boolean => !readOnly;

/**
 * Событие из портала (диалог удаления всплывает по дереву React в tr) лежит
 * вне DOM строки и перехода не вызывает.
 */
export const shouldNavigateFromRow = (
  row: { contains: (node: any) => boolean },
  target: ClosestTarget,
): boolean => row.contains(target) && isRowActivation(target);
